import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-file-upload',
  standalone: true,
  imports: [TranslateModule, TablerIconsModule, CommonModule, MaterialModule],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss'
})
export class FileUploadComponent {
  @Input() fileName = '';
  @Input() acceptedFiles = '*';
  @Output() fileChanged = new EventEmitter<File>();
  @Input() imageUrl: string | ArrayBuffer | null = null;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {}

  onFileSelected(event: any) {

    const file: File = event.target.files[0];

    if (file) {
      this.fileChanged.emit(file);

      this.fileName = file.name;

      // Crear un FileReader para leer el archivo
      const reader = new FileReader();

      // Definir qué hacer cuando el FileReader haya cargado el archivo
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result; // Asignar la URL de la imagen
      };

      // Leer el archivo como una URL de datos
      reader.readAsDataURL(file);
    }
  }
}
